<script lang="ts">
	import { Share } from 'lucide-svelte';
	import { onMount } from 'svelte';
	import { page } from '$app/stores';
	import { error } from '@sveltejs/kit';

	if (!$page.data.textData)
		throw error(500, {
			message: 'No textData found in PageData object. Check ArchieML file.',
			file: 'src/components/Navbar/menu/ShareButton.svelte',
		});

	let shareData = {
		title: $page.data.textData.meta.title,
		text: $page.data.textData.meta.description,
		url: window.location.href,
	};

	function handleShare() {
		navigator
			.share(shareData)
			.then(() => console.log('Successful share'))
			.catch((error) => console.log('Error sharing', error));
	}

	onMount(() => {
		if (navigator.canShare()) {
			console.log('navigator.share is supported');
		} else {
			console.log('navigator.share is not supported');
		}
	});
</script>

<div class="share-button-container">
	<button type="button" class="btn-icon btn-icon-xl variant-filled"
		><Share size="{28}" on:click="{handleShare}" /></button
	>
</div>

<style lang="scss">
	@use '$styles/colors' as *;
	button {
		float: right;
		margin: 20px;
		background: $rfe-gray-3;
	}
</style>
